// extracted by mini-css-extract-plugin
export default {"overlay":"AppOverlay_overlay__bTVQO"};